export const InvoicePaymentHistoyTypes = {
    1: "Online Payment",
    2: "Twinfield",
    3: "Manual Payment",
    4: "Online Payment (CMS)",
    5: "Xero",
    6: "Exact Online"
}